import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { BaseApiService } from '@data-access/common/base-api.service';
import { ImageCreateData } from '@shared/interfacres/image';

@Injectable({providedIn: 'root'})
export class CarouselManagerService extends BaseApiService {


  getList()  {
    const requestUrl = `${this.apiUrl}/admin/settings/carousel-images`;
    return this._httpClient.get(requestUrl).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    )
  }

  create(data: ImageCreateData) {
    const formData = new FormData();
    if (data.file) {
      formData.append('image', data.file, data.file.name);
    }

    if (data.name) {
      formData.append('name', data.name);
    }

    if (data.url) {
      formData.append('url', data.url);
    }

    const url = `${this.apiUrl}/admin/settings/carousel-images/with-image`;
    return this._httpClient.post(url, formData).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }

  update(id: number, data: ImageCreateData) {
    const formData = new FormData();
    if (data.file) {
      formData.append('image', data.file, data.file.name);
    }

    if (data.url) {
      formData.append('url', data.url);
    }
    if (data.name) {
      formData.append('name', data.name);
    }

    const url = `${this.apiUrl}/admin/settings/carousel-images/${id}/with-image`;
    return this._httpClient.patch(url, formData).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }

  delete(id: number) {
    const url = `${this.apiUrl}/admin/settings/carousel-images/${id}`;
    return this._httpClient.delete(url).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }
}
